import axiosInstance from '../../axios-config';

const localizedContentUrl = 'api/content/{contentKey}?language={languageCode}';
const localizedFacilityContentUrl = 'api/content/{contentKey}/facilityToken/{facilityId}?&language={languageCode}';

export const getLocalizedContent = (contentKey, languageCode) => (
  axiosInstance.get(localizedContentUrl
    .replace('{contentKey}', contentKey)
    .replace('{languageCode}', languageCode))
);

export const getLocalizedFacilityContent = (contentKey, facilityId, languageCode) => (
  axiosInstance.get(localizedFacilityContentUrl
    .replace('{contentKey}', contentKey)
    .replace('{facilityId}', facilityId)
    .replace('{languageCode}', languageCode))
);